import Loader from "react-loader-spinner";
import styles from "./UploadGridItem.module.css";

const ProcessingDocument = (props: any) => (
    <div className={props.selectedStyle}>
        <div className={styles.ProccessingStateText}>
            <div>
                <Loader
                    type="ThreeDots"
                    color="#00BFFF"
                    height={30}
                    width={30}
                />
                <b> Processing Document </b>
            </div>
        </div>
    </div>
);
export default ProcessingDocument;
